import React from 'react';
import { Link } from 'react-router-dom';
import { FOOTER_NAV_LINKS } from './footerLinks';

/**
 * Shared footer markup. Desktop: used inside collapsible Footer.
 * Mobile sheet: compact block at bottom of hamburger menu.
 */
export function FooterContent({ variant = 'bar', isExpanded = true, onNavigate }) {
  const currentYear = new Date().getFullYear();
  const isSheet = variant === 'sheet';

  if (isSheet) {
    return (
      <div className="footer-sheet" aria-label="Sidefod">
        <h3 className="footer-sheet-title">vuggestueguiden.dk</h3>
        <p className="footer-sheet-description">
          Din guide til at finde den bedste daginstitution for dit barn.
          Sammenlign institutioner baseret på officielle tilsynsrapporter.
        </p>
        <ul className="footer-links footer-links--sheet">
          {FOOTER_NAV_LINKS.map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="footer-link" onClick={onNavigate}>{item.label}</Link>
            </li>
          ))}
        </ul>
        <p className="footer-sheet-copyright">
          © {currentYear} Vuggestueguiden. Alle rettigheder forbeholdes.
        </p>
      </div>
    );
  }

  return (
    <>
      <div className={`footer-content ${isExpanded ? 'visible' : 'hidden'}`}>
        <div className="footer-section">
          <h3 className="footer-title">vuggestueguiden.dk</h3>
          <p className="footer-description">
            Din guide til at finde den bedste daginstitution for dit barn.
            Sammenlign institutioner baseret på officielle tilsynsrapporter.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-section-title">Navigation</h4>
          <ul className="footer-links">
            {FOOTER_NAV_LINKS.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className="footer-link" onClick={onNavigate}>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © {currentYear} Vuggestueguiden. Alle rettigheder forbeholdes.
          </p>
        </div>
      </div>
    </>
  );
}

export default FooterContent;
